import React from 'react';
import styled from 'styled-components';
import { createMuiTheme, ThemeProvider } from '@material-ui/core/styles';
import { useHistory } from 'react-router-dom';
import config from '@/configs/config';
import HowToIcon from './HowToIcon';
import defaultTheme from './defaultTheme';
import CampaignModal from '../../ooha202304/containers/CampaignModal';

const WIDTH_FOR_MOBILE = 796;

const AddButton = styled.button`
  align-items: center;
  background-color: #337024;
  border-radius: 6px;
  box-shadow: 0px 2px 5px #7d7d7d;
  border: 0;
  color: #fdfdfd;
  display: flex;
  font-size: 16px;
  font-weight: bold;
  height: 53px;
  justify-content: center;
  cursor: pointer;
`;

const Container = styled.div`
  text-align: center;
  max-width: ${WIDTH_FOR_MOBILE}px;
  margin: 0 auto;
  min-height: calc(100vh - 100px);
  & .background {
    position: absolute;
    left: 0;
    background: url("/images/AboutUs/background_mobile.jpg") no-repeat center center;
    width: 100%;
    height: 300px;
    background-size: cover;
    & div{
      top: 50%;
      position: absolute;
      width: 100%;
      transform: translate(0,-100%);
      color: black;
      font-weight: bold;
      font-size: 32px;
      white-space: pre;
    }
    & button{
      position: absolute;
      left: 50%;
      top: 51%;
      transform: translate(-50%,50%);
      width: 291px;
    }
  }
  & .background2 {
    position: absolute;
    left: 0;
    background: url("/images/AboutUs/background2_mobile.jpg") no-repeat center center;
    width: 100%;
    height: 200px;
    background-size: cover;
    & div{
      display: none;
    }
    & img{
      position: absolute;
      left: 50%;
      top: 50%;
      transform: translate(-50%,50%);
      width: 300px;
    }
    & button{
      position: absolute;
      left: 50%;
      top: 51%;
      transform: translate(-50%,50%);
      width: 291px;
    }
  }
  @media (min-width: ${WIDTH_FOR_MOBILE}px) {
    & {
      padding-bottom: 280px;
    }
    & .background {
      background: url("/images/AboutUs/background_mobile.jpg") no-repeat center center;
      background-size: cover;
      height: 500px;
      & div{
        white-space: nowrap;
      }
    }
    & .background2 {
      background: url("/images/AboutUs/background2_desktop.jpg") no-repeat center center;
      background-size: cover;
      height: 300px;
      & div{
        font-weight: bold;
        font-size: 32px;
        white-space: pre;
        color: black;
        display: inline-block;
        text-align: left;
        position: absolute;
        transform: translate(0, 50%);
        left: 60%;
      }
      & button{
        left: 60%;
        transform: none;
      }
    }
  }
`;

const Content = styled.div`
  font-size: 16px;
  color: ${(props) => (props.color || 'rgb(79, 79, 79)')};
  margin: 30px;
  line-height: 30px;
  text-align: justify;
`;

const HowToSection = styled.div`
  text-align: center;
  & .desktop{
    display: none !important;
  }
  position: relative;
  & .background-color {
    top: 0;
    position: absolute;
    background-color: rgb(44, 44, 54);
    min-height: 100px;
    width: 100%;
    height: 100%;
    z-index: -1;
  }
  & .howto-title{
    white-space: nowrap;
    text-align: left;
  }
  & .howto-icon{
    display: inline-block;
    vertical-align: top;
    margin-left: 30px;
    margin-top: 30px;
  }
  & .howto-slogan{
    white-space: pre;
    display: inline-block;
    vertical-align: top;
    color: rgb(240, 191, 40);
    font-size: 20px;
    font-weight: bold;
    text-align: left;
    margin-left: 20px;
    margin-top: 30px;
  }
  & .sub_guide{
    display: inline-block;
    vertical-align: top;
    width: calc((100% - 60px)/3 - 10px);
    margin: 10px;
  }
  & .guide{
    margin-bottom: 30px;
    margin-top: 10px;
    width: 100%;
  }
  @media (min-width: ${WIDTH_FOR_MOBILE}px) {
      & .mobile{
        display: none !important;
      } 
      & .desktop{
        display: block !important;
      }
      & .background-color {
        width: 100vw;
        height: 350px;
        margin-left: calc(0px - (100vw - 100%) / 2);
      }
      & .howto-slogan{
        white-space: nowrap;
        margin: 30px 0 0 0;
        width: 100%;
        text-align: center;
      }
      & .howto-icon.desktop{
        position: absolute;
        margin-top: 10px;
      }
      & .sub_guide{
        width: calc((100% - 240px)/3 - 10px);
        margin: 10px;
      }
      & .guide{
        margin: 10px auto 30px auto;
        width: calc(100% - 240px);
      }
  }
`;

export default () => {
  const theme = createMuiTheme(defaultTheme);
  const history = useHistory();
  const onAddFriendClick = () => {
    history.push('/register');
  };

  if (config.aboutUsPageRedirection) {
    history.push(config.aboutUsPageRedirection);
    return <Container />;
  }

  return (
    <ThemeProvider theme={theme}>
      <CampaignModal />
      <div className="
          fz-bg-[url(/images/AboutUs/background_mobile.jpg)]
          fz-bg-center
          fz-bg-cover
          fz-bg-no-repeat
          fz-flex
          fz-flex-col
          fz-gap-4
          fz-h-[300px]
          fz-items-center
          fz-justify-center
          fz-w-full
          md:fz-h-[500px]
        "
      >
        <div className="fz-text-3xl fz-font-bold fz-flex fz-flex-col fz-items-center md:fz-flex-row">
          <span>忙裡偷閒</span>
          <span>CHILL一下</span>
        </div>
        <AddButton onClick={onAddFriendClick}>
          加入
          {config.BrandNameTW}
          ，享機台商品首購7折
        </AddButton>
      </div>
      <div className="fz-container fz-m-auto fz-flex fz-flex-col fz-items-center fz-mt-8 fz-max-w-screen-md fz-px-8">
        <span className="fz-text-xl fz-font-bold">好近的微型無人商店</span>
        <span className="fz-leading-loose">
          「
          {config.BrandNameTW}
          」 是一個小小的無人商店，座落在城市的各個角落，
          努力的開在離您最近的地方滿足您最及時的需求，
          採用信用卡 / LINE Pay支付、自助購餐、自動結帳的消費方式，讓您隨時從容購餐。
        </span>
        <div className="fz-flex fz-flex-col md:fz-flex-row fz-mt-4 fz-gap-8">
          <div className="fz-flex fz-gap-4">
            <img className="fz-w-[80px] fz-h-[80px] fz-object-contain md:fz-hidden" src="/images/AboutUs/item1.png" alt="" />
            <div className="fz-flex fz-flex-col fz-gap-2 md:fz-items-center">
              <span className="fz-font-bold fz-text-xl">24小時自助購餐</span>
              <img className="fz-w-[120px] fz-h-[120px] fz-object-contain fz-hidden md:fz-block" src="/images/AboutUs/item1.png" alt="" />
              <span>
                忙過頭忘了吃飯還是下午茶時間有點嘴饞？
                {config.BrandNameTW}
                24小時自助購餐，隨時忙裡偷閒CHILL一下。
              </span>
            </div>
          </div>
          <div className="fz-flex fz-gap-4">
            <img className="fz-w-[80px] fz-h-[80px] fz-object-contain md:fz-hidden" src="/images/AboutUs/item2.png" alt="" />
            <div className="fz-flex fz-flex-col fz-gap-2 md:fz-items-center">
              <span className="fz-font-bold fz-text-xl">每天變換菜單</span>
              <img className="fz-w-[120px] fz-h-[120px] fz-object-contain fz-hidden md:fz-block" src="/images/AboutUs/item2.png" alt="" />
              <span>「每日架上鮮食」嚴選各地人氣餐廳美食，每日新鮮配送，天天嚐鮮不無聊。點選您所在機台位置還可觀看即時庫存！</span>
            </div>
          </div>
          <div className="fz-flex fz-gap-4">
            <img className="fz-w-[80px] fz-h-[80px] fz-object-contain md:fz-hidden" src="/images/AboutUs/item3.png" alt="" />
            <div className="fz-flex fz-flex-col fz-gap-2 md:fz-items-center">
              <span className="fz-font-bold fz-text-xl">選品線上購</span>
              <img className="fz-w-[120px] fz-h-[120px] fz-object-contain fz-hidden md:fz-block" src="/images/AboutUs/item3.png" alt="" />
              <span>
                「選品線上購」服務讓您線上下單，到貨後在
                {config.BrandNameTW}
                機台輕鬆取貨，省下運費，下班提了就走！
              </span>
            </div>
          </div>
        </div>
      </div>

      <HowToSection className="fz-mt-8 fz-max-w-screen-md fz-mx-auto">
        <div className="background-color" />
        <div className="howto-title">
          <div className="howto-icon mobile">
            {' '}
            <HowToIcon />
          </div>
          <div className="howto-slogan">{'怎麼購餐？\n開門、關門，就這麼簡單'}</div>
        </div>
        <Content color="white">
          「
          {config.BrandNameTW}
          」 購餐無需預訂，您可以打開櫃門自在的選購，關上門後系統將自動感應並自動結帳，再將購餐明細發送到您的手機。
        </Content>
        <div className="howto-icon desktop">
          {' '}
          <HowToIcon />
        </div>
        <img src="/images/AboutUs/guide1.png" alt="" className="sub_guide" />
        <img src="/images/AboutUs/guide2.png" alt="" className="sub_guide" />
        <img src="/images/AboutUs/guide3.png" alt="" className="sub_guide" />
        <img src="/images/AboutUs/guide_mobile.png" alt="" className="guide mobile" />
        <img src="/images/AboutUs/guide_desktop.png" alt="" className="guide desktop" />
      </HowToSection>

      <div className="
        fz-bg-[url(/images/AboutUs/background2_mobile.jpg)]
        fz-bg-center
        fz-bg-cover
        fz-bg-no-repeat
        fz-flex
        fz-h-[200px]
        fz-items-center
        fz-justify-center
        fz-w-full
        md:fz-bg-[url(/images/AboutUs/background2_desktop.jpg)]
        md:fz-h-[300px]
      "
      >
        <div className="fz-flex fz-flex-col fz-translate-y-full fz-gap-4 md:fz-translate-y-0 md:fz-translate-x-full">
          <div className="fz-text-3xl fz-font-bold fz-flex-col fz-hidden md:fz-flex">
            <span>忙裡偷閒</span>
            <span>CHILL一下</span>
          </div>
          <AddButton onClick={onAddFriendClick}>
            加入
            {config.BrandNameTW}
            ，享機台商品首購7折
          </AddButton>
        </div>
      </div>
    </ThemeProvider>
  );
};
